<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Importazione da cartella</h1>
      </div>
      <p class="editor-lead">I dati comuni vengono applicati alla scheda copiata dall'archivio temporaneo.</p>
      <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
    </header>

    <form class="editor-form" [formGroup]="importForm">
      <section class="editor-panel">
        <h2>Classificazione</h2>
        <div class="field-grid classification-grid">
          <div class="field-block">
            <label for="category">Categoria<sup>*</sup></label>
            <select id="category" class="field" formControlName="category"
              [class.is-invalid]="importForm.get('category')?.invalid && (importForm.get('category')?.dirty || importForm.get('category')?.touched)">
              <option [ngValue]="null" disabled>Seleziona una categoria</option>
              @for (item of categoryOptions; track item.id) {
                <option [ngValue]="item">{{ item.title }}</option>
              }
            </select>
          </div>

          <div class="field-block">
            <label for="subcategory">Sottocategoria<sup>*</sup></label>
            <select id="subcategory" class="field" formControlName="subcategory"
              [class.is-invalid]="importForm.get('subcategory')?.invalid && (importForm.get('subcategory')?.dirty || importForm.get('subcategory')?.touched)">
              <option [ngValue]="null">Seleziona una sottocategoria</option>
              @for (option of subcategoryOptions; track option.id) {
                <option [ngValue]="option">{{ option.title }}</option>
              }
            </select>
          </div>

          <div class="field-block visibility-block">
            <span class="field-label">Visibilità articolo</span>
            <div class="visibility-controls">
              <label class="switch" for="public">
                <input id="public" type="checkbox" role="switch" formControlName="public" (change)="enableDisablePublication()">
                <span class="switch-track" aria-hidden="true"></span>
                <span>Pubblico</span>
              </label>
              @if (importForm.get('public')?.value == 1) {
                <input id="public_year" class="field" type="text" inputmode="numeric" maxlength="4" placeholder="Anno"
                  formControlName="public_year" aria-label="Anno pubblicazione"
                  (input)="isCorrectPublicYear()"
                  [class.is-invalid]="importForm.get('public_year')?.invalid && (importForm.get('public_year')?.dirty || importForm.get('public_year')?.touched)">
              }
            </div>
          </div>
        </div>
      </section>

      <section class="editor-panel">
        <h2>Luogo</h2>
        <div class="field-grid field-grid-3">
          <div class="field-block">
            <label for="city">Città</label>
            <input id="city" class="field" type="text" placeholder="Città" matInput [matAutocomplete]="city"
              formControlName="city"
              [class.is-invalid]="importForm.get('city')?.invalid && (importForm.get('city')?.dirty || importForm.get('city')?.touched)">
            <mat-autocomplete #city="matAutocomplete" class="editor-city-panel" panelClass="editor-city-panel"
              [displayWith]="displayCityName">
              @for (option of filteredCity$ | async; track option.id) {
                <mat-option [value]="option">{{ option.name }}</mat-option>
              }
            </mat-autocomplete>
          </div>

          <div class="field-block">
            <label for="pointofinterest">Luogo d'interesse</label>
            <input id="pointofinterest" class="field" type="text" placeholder="Luogo" formControlName="pointofinterest">
          </div>

          <div class="field-block">
            <label for="storage_place">Luogo di conservazione<sup>*</sup></label>
            <input id="storage_place" class="field" type="text" placeholder="Luogo" formControlName="storage_place"
              [class.is-invalid]="importForm.get('storage_place')?.invalid && (importForm.get('storage_place')?.dirty || importForm.get('storage_place')?.touched)">
          </div>
        </div>

        <div class="place-grid">
          <div class="field-block">
            <label for="floor">Piano<sup>*</sup></label>
            <input id="floor" class="field" type="text" placeholder="Piano edificio" formControlName="floor"
              [class.is-invalid]="importForm.get('floor')?.invalid && (importForm.get('floor')?.dirty || importForm.get('floor')?.touched)">
          </div>
          <div class="field-block">
            <label for="room">Stanza<sup>*</sup></label>
            <input id="room" class="field" type="text" formControlName="room"
              [class.is-invalid]="importForm.get('room')?.invalid && (importForm.get('room')?.dirty || importForm.get('room')?.touched)">
          </div>
          <div class="field-block">
            <label for="rack">Scaffale / armadio<sup>*</sup></label>
            <input id="rack" class="field" type="text" formControlName="rack"
              [class.is-invalid]="importForm.get('rack')?.invalid && (importForm.get('rack')?.dirty || importForm.get('rack')?.touched)">
          </div>
          <div class="field-block">
            <label for="shelf">Ripiano<sup>*</sup></label>
            <input id="shelf" class="field" type="text" formControlName="shelf"
              [class.is-invalid]="importForm.get('shelf')?.invalid && (importForm.get('shelf')?.dirty || importForm.get('shelf')?.touched)">
          </div>
          <div class="field-block">
            <label for="case">Contenitore<sup>*</sup></label>
            <input id="case" class="field" type="text" formControlName="case"
              [class.is-invalid]="importForm.get('case')?.invalid && (importForm.get('case')?.dirty || importForm.get('case')?.touched)">
          </div>
        </div>
      </section>

      @if (!importForm.valid) {
        <p class="editor-hint">Compila correttamente tutti i campi per abilitare il caricamento.</p>
      }
    </form>

    <section class="archives" aria-label="Archivi">
      <p class="editor-lead">Copia una cartella dall'archivio temporaneo. La scheda viene poi cancellata da lì.</p>
      <div class="archives-grid">
        <app-tree-view #treeView0 (saveArticle_tree)="insertArticle($event)" [archive_type]="0"></app-tree-view>
        <app-tree-view #treeView1 [archive_type]="1"></app-tree-view>
      </div>
    </section>
  </div>
</div>
